export const IAOptionsStyles = {
	display: 'flex',
	alignItems: 'center',
	backgroundColor: 'rgb(255, 255, 255)',
	boxShadow: 'rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgba(145, 158, 171, 0.12) 0px 12px 24px -4px',
	borderRadius: '12px',
	padding: 2,
	mb: 3,
	width: '100%',

	"&:hover": {
		cursor: 'pointer', backgroundColor: 'primary.lighter'
	}
}

export const IAOptionsSelectedStyles = {
	...IAOptionsStyles,
	border: '2px solid',
	borderColor: 'primary.light',
	boxShadow: '-1px 0px 14px 5px rgba(205,205,205,1)'
}